__webpack_public_path__ = window.REBELMOUSE_BASE_ASSETS_URL;

import startApp from "./app";
import getContext from "./context";

export default function onDomReady() {
    startApp(getContext());
}
